import * as React from 'react';
import {useStyletron} from 'baseui';
import {Button, KIND, SHAPE, SIZE} from 'baseui/button';
import Alert from 'baseui/icon/alert';

export default function FetchErrorComponent(
    {
        onRefresh,
        error,
        message ,
    }
) {
  const [css, theme] = useStyletron();
  return (
    <div
      className={css({
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      })}
    >
      <Alert 
        overrides={{
          Svg: {
            style: {
              color: theme.colors.negative,
            },
          },
        }}
       size={theme.sizing.scale1600} />
      <div
        className={css({
          ...theme.typography.HeadingXSmall,
          paddingBlockStart: theme.sizing.scale650,
          paddingBlockEnd: theme.sizing.scale500,
        })}
      >
        {"Oops, Something went wrong"}
      </div>
      {/* <div
        className={css({
          ...theme.typography.ParagraphMedium,
          paddingBlockEnd: theme.sizing.scale650,
        })}
      >
        {message}
      </div> */}
      <Button
        onClick={onRefresh}
        kind={KIND.secondary}
        shape={SHAPE.pill}
        size={SIZE.compact}
      >
        Try Again
      </Button>
    </div>
  );
}